/**
 * @param {object} zwibbler
 * @param {array} nodes
 * @param {string} property
 * @param {string} value
 */
export const setNodeProperty = (
  zwibbler,
  { nodes = [], property, value = "" }
) => {
  if (nodes.length === 0) {
    nodes = zwibbler.getSelectedNodes();
  }

  nodes.forEach(node => {
    zwibbler.setNodeProperty(node, property, value);
  });
};

/**
 * @param {object} zwibbler
 * @param {array} nodes
 * @param {object} properties
 */
export const setNodeProperties = (zwibbler, { nodes = [], properties }) => {
  if (nodes.length === 0) {
    nodes = zwibbler.getSelectedNodes();
  }

  nodes.forEach(node => {
    zwibbler.setNodeProperties(node, properties);
  });
};

/**
 *
 * @param {object} zwibbler
 * @param {array} nodes
 */
export const getNodeSummaryProperties = (zwibbler, nodes = []) => {
  if (nodes.length === 0) {
    nodes = zwibbler.getSelectedNodes();
  }

  return zwibbler.getPropertySummary(nodes);
};

/**
 *
 * @param {object} zwibbler
 * @param {array} nodes
 * @param {array} properties
 */
export const getNodeProperties = (zwibbler, nodes = [], properties) => {
  if (nodes.length === 0 || !Array.isArray(nodes)) {
    nodes = zwibbler.getSelectedNodes();
  }

  const getProps = (node, propsArray) => {
    const obj = {};
    propsArray.forEach(prop => {
      obj[prop] = zwibbler.getNodeProperty(node, prop);
      obj.node = node;
    });
    return obj;
  };
  return nodes.map(node => {
    return getProps(node, properties);
  });
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/ExternalApi/handlers/Properties.js